<script lang="ts">
	export let tag: string = 'h1';
	export let text: string;
	let classname = '';
	export { classname as class };
</script>

<svelte:element this={tag} class={classname}>
	<span class="block font-extrabold italic text-white">
		<span class="stage-headline inline-block !leading-[90%] max-w-[34.25rem]">
			{text}
		</span>
	</span>
</svelte:element>

<style class="postcss">
	.stage-headline {
		font-size: 2.25rem;
	}

	@media screen and (min-width: 420px) {
		.stage-headline {
			font-size: 3rem;
		}
	}

	@media screen and (min-width: 640px) {
		.stage-headline {
			font-size: 3.75rem;
		}
	}
</style>
